
import { Component, Directive, OnInit, ViewEncapsulation, OnDestroy, Inject, forwardRef } from '@angular/core';
import { BreadcrumbService } from '../../breadcrumb.service';
import { NgIf } from '@angular/common';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { EspacioFormulario } from '../../domain/EspacioFormulario';
import { Noticia } from './../../domain/Noticia';
import { GrowlModule, Message } from 'primeng/primeng';
import { ConfirmationService } from 'primeng/api';
import * as allSettled from 'promise-all-settled';
import { Router } from '@angular/router';
import { Constantes } from './../../domain/constantes';
import { isUndefined } from 'util';
import {TranslatePipe, TranslateService, LangChangeEvent} from 'ng2-translate';
import { AppComponent } from '../../app.component';
import { environment } from '../../../environments/environment';


@Component({
	templateUrl: './Noticias.component.html',
    providers: [ConfirmationService]
})

export class NoticiasComponent implements OnInit, OnDestroy {

	public EXPIRADO = 0;
	public PROXIMO = 1;
	public EXPIRA = 2;
	public ACTIVO = 3;

	spinner: HTMLElement;
	blockUI: HTMLElement;
	public msgs = [];
	public noticias: Noticia[] = [];

	public cols;

	public espacioSeleccionado: EspacioFormulario = new EspacioFormulario();
	public noticiaSeleccionado: Noticia = new Noticia();

	/* ** @INPUTS de p-dialog ** */
	public visible: boolean;

	constructor(
		private appComponent: AppComponent,
		private breadcrumbService: BreadcrumbService,
		private router: Router,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private entityManager: EntityManagerProvider,
		private confirmationService: ConfirmationService,
		private translate: TranslateService
	) {
		console.log('*** NoticiasComponent ***');
		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Noticias.noticias') }
		]);
		this.cols = [
			{ field: 'Imagen', header: this.translate.instant('Noticias.imagen') },
			{ field: 'Titulo', header: this.translate.instant('Noticias.titulo') },
			{ field: 'TextoContenido', header: this.translate.instant('Noticias.contenido') },
			{ field: 'ExpiracionMensaje', header: this.translate.instant('Noticias.estado') },
			{ field: 'MostrarEdicion', header: '' }
		];

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
		this.blockUI.style.display = 'none';
	}

	ngOnInit() {
		const that = this;
		window.scroll(0, 0);
		// Mostramos Spinner
		this.spinner.style.display = 'inherit';
		const idEspacio = this.authService.getIdEspacio();
		this.entityManager.getEspacioConNoticiasById(idEspacio)
		.then(function (espacio: any) {

			if (espacio !== undefined) {
				that.espacioSeleccionado.Nombre = espacio.Nombre;
				that.espacioSeleccionado.Descripcion = espacio.Descripcion;
				that.espacioSeleccionado.ENTIDAD = espacio;

				return that.prepararNoticiasCell(that.espacioSeleccionado.ENTIDAD.NOTICIAS);
			}
			else{
				return false;
			}
		})
		.then(function () {
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
			console.log('*** prepararNoticiasCell OK ***');
		})
		.catch(function (e) {
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
			that.appComponent.showError(e);
			return false;
		});
	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	addNuevaNoticia() {
		this.router.navigate(['/noticias/nueva', {}]);
	}

	editarNoticia(elemento: any) {
		this.router.navigate(['/noticias/nueva', { id: this.noticiaSeleccionado.ENTIDAD.Id }]);
	}

	eliminarNoticia(elemento: any) {
		const that = this;

		this.confirmationService.confirm({
			message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_ELIMINAR'),
			header: this.translate.instant('MensajesConfirmacion.MENSAJE_CABECERA_CONFIRMACION'),
			icon: 'fa fa-question-circle',
			accept: () => {
				this.entityManager.deleteNOTICIA(elemento.ENTIDAD);
				this.entityManager.saveChanges()
				.then(function () {
					that.noticias = that.noticias.filter((val, i) => val.ENTIDAD.Id !== elemento.ENTIDAD.Id);
					that.spinner.style.display = 'none';
				})
				.catch(function (e) {
					that.appComponent.showError(e.message);
					that.spinner.style.display = 'none';
					return false;
				});
			},
			reject: () => {
				that.spinner.style.display = 'none';
			}
		});
	}

	mostrarEditar(noticia) {
		this.noticiaSeleccionado = noticia;
		this.noticiaSeleccionado.MostrarEdicion = true;
	}

	ocultarEditar(noticia) {

		noticia.MostrarEdicion = false;
	}

	prepararNoticiasCell(noticias): Noticia[] {
		const that = this;
		this.noticias = [];
		const promises: any[] = [];
		const token = that.authService.getToken();

		noticias.forEach(not => {

			const noticia = new Noticia(not);

			noticia.Imagen = this.authService.getFotoPorDefecto();
			// FOTOS
			const ultima = noticia.ENTIDAD.FOTOS.length - 1;
			if (ultima >= 0) {
				if (noticia.ENTIDAD.FOTOS[ultima].UrlFotoExt) {
					noticia.Imagen = noticia.ENTIDAD.FOTOS[ultima].UrlFotoExt;
				}
				else{
					noticia.Imagen =  environment.urlBaseFotos + noticia.ENTIDAD.FOTOS[ultima].IdFotoExt;
				}
			}
			else {
				noticia.Imagen = this.authService.getFotoPorDefecto();
			}


			that.noticias.push(noticia);
		});

		return that.noticias;

	}

	/* **  Gestion Mensajes ** */
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'error',  detail: mensaje});
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'success',  detail: mensaje});
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Noticias/Noticias.component.ts